<template>
  <b-modal
    ref="notificationDetailModal"
    centered
    modal-class="notification-detail-modal"
    qa="notification-detail-modal"
  >
    <div slot="modal-title">
      <span v-if="!notification.alarm">{{ $t('notifications.notificationDetail') }}</span>
      <span v-if="notification.alarm">{{ $t('notifications.alarmDetail') }}</span>
    </div>
    <b-row class="px-3 notification-detail-header">
      <b-col cols="8">
        <i
          :class="[isEvent(notification) ? 'far fa-calendar-alt' : 'fal fa-chart-network']"
          class="mt-1 main"
          aria-hidden="true"
        />
        <span
          v-if="isEvent(notification)"
          class="mx-2 entity-title label-dark"
        >{{ $tc('component.calendar.event', 1) | capitalize }}</span>
        <span
          v-else
          class="mx-2 entity-title label-dark"
        >{{ notification.label }}</span>
      </b-col>
      <b-col class="d-flex justify-content-end align-items-center">
        <b-badge
          pill
          class="badge-vt-success mx-2"
        >
          {{ $tc('global.read', 1) }}
        </b-badge>
      </b-col>
    </b-row>
    <b-row class="px-2 mt-4 notification-detail-subheader">
      <b-col>
        <div class="d-flex flex-column justify-content-center align-items-center">
          <small>{{ $tc('global.laboratory',1) }}</small>
          <span class="label-dark">{{ notification.laboratory }}</span>
        </div>
      </b-col>
      <b-col
        class="px-0 d-flex align-items-center"
        cols="auto"
      >
        <div class="notifications-detail-line" />
      </b-col>
      <b-col>
        <div class="d-flex flex-column justify-content-center align-items-center">
          <small>{{ $t('notifications.dateTime') }}</small>
          <span class="label-dark">{{ notification.timestamp | datetime }}</span>
        </div>
      </b-col>
    </b-row>
    <b-row class="px-2 mt-3">
      <b-col>
        <div
          class="notifications-detail-message component-inside-2 py-3 px-4"
          :class="{'notifications': !notification.alarm, 'alerts': notification.alarm}"
        >
          <span class="message-title label-dark">{{ notification.subject }}</span>
          <div>
            <span
              class="message-description"
              v-html="notification.body"
            />
          </div>
        </div>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.close') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>

import notificationService from '@/components/NavBar/notifications/services/notificationService'
import { NOTIFICATION_TYPE } from '@/components/NavBar/notifications/constants/notificationTypes'
export default {
    name: 'NotificationDetailModal',
    data() {
        return { notification: {} }
    },
    computed: {
        NOTIFICATION_TYPE() {
            return NOTIFICATION_TYPE
        }
    },
    methods: {
        async show(notification) {
            this.notification = notification
            this.$refs.notificationDetailModal.show()
            if (!notification.read) {
                await notificationService.updateNotificationAsRead(notification.id)
                this.$emit('reload', notification)
            }
        },
        isEvent(notification) {
            return notification.notificationType === NOTIFICATION_TYPE.PERSONNEL_EVENT_MANAGED || notification.notificationType === NOTIFICATION_TYPE.NEW_UNCONFIRMED_PERSONNEL_EVENT
        },
        hide() {
            this.$refs.notificationDetailModal.hide()
        }
    }
}
</script>

<style lang="scss">
.notification-detail-modal .modal-dialog {
  max-width: 35% !important;
}

.notification-detail-modal .notification-detail-header{
  font-size: font-size(big);
}

.notification-detail-modal .notification-detail-header .entity-title{
  color: vt-color(dark-text);
}

.notification-detail-modal .notification-detail-header .time{
  font-size: font-size(normal);
}

.notification-detail-modal .notifications-detail-line{
  width:1px;
  height: 30px;
  background:vt-color(base-text, .7);
}

.notification-detail-modal .notification-detail-subheader small{
  text-transform: uppercase;
}

.notification-detail-modal .notification-detail-subheader span{
  color: vt-color(dark-text);
}

.notification-detail-modal .notifications-detail-message{
  background: vt-color(base-text, .95);
  border-radius: 5px;
}

.notifications-detail-message.notifications{
  border-left: 5px solid vt-color(orange-medium);
}

.notifications-detail-message.alerts{
  border-left: 5px solid rgb(209, 56, 56);
}

.notification-detail-modal .message-title{
  color: vt-color(dark-text);
}

</style>
